import { memo } from "react";
import TextField from "../TextField";
import { MaskedInputProps } from "./props.type";
import { Box } from "@mui/material";
import { formatMaskedValue } from "@/utils/maskFormat";

const MaskedInput = (props: MaskedInputProps) => {
  const {
    inputProps,
    mask,
    ContainerProps,
    setValue,
    blockChars,
    onChange,
    onBlur,
    onFocus,
    value,
    label,
    disabled,
    error,
    errorText,
    InputProps,
  } = props;

  return (
    <Box {...ContainerProps}>
      <TextField
        label={label}
        disabled={disabled}
        error={error}
        helperText={error ? errorText : undefined}
        InputProps={InputProps}
        inputProps={inputProps}
        value={value ?? ""}
        blockChars={blockChars}
        setValue={(v) => {
          setValue?.(formatMaskedValue(v, mask));
        }}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </Box>
  );
};

export default memo(MaskedInput);
